import React from 'react';

import { IBadgeListFields } from '../../../types/contentful';

import { Badge } from './Badge';

interface Props extends IBadgeListFields {
  sysId?: string;
}

export function BadgeList({ badges, heading, sysId }: Props) {
  return (
    <div
      className="block-container"
      data-eltype="badge-list"
      data-blockid={sysId}
      id={sysId}
      data-testid="badgeList"
    >
      <div className="layout layout-padding !py-0">
        {!!heading && (
          <div className="column mb-6 w-full justify-center desktop:mb-12">
            <h2
              className="heading-2 text-center"
              data-elementid="badge-list-heading"
            >
              {heading}
            </h2>
          </div>
        )}
        <div className="flex max-w-screen-max flex-col content-start items-start gap-10 self-stretch tablet:flex-row tablet:flex-wrap tablet:gap-x-2 tablet:gap-y-10 desktop:flex-nowrap desktop:justify-center desktop:gap-8">
          {(badges || []).map(({ fields }, index) => (
            <Badge key={index} {...fields} />
          ))}
        </div>
      </div>
    </div>
  );
}
